import { GET_ORDER_DETAILS } from "../components/Shared/constant";

const GetOrderDetails = async (accessToken, slug) => {
    const responce = window.axios.get(`${GET_ORDER_DETAILS}/${slug}/100/1`, {
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + accessToken,
    }}).then(function (result) {
        return {
          ...result.data,
          status:200
        };
    }).catch(function (result) {
        return {
          ...result?.response?.data,
          status:result?.response?.status
        }
    });
    return responce;
};
  
export default GetOrderDetails;